<div class="container">

    <h3>Device Auditing</h3>
    @if (!isLoading){
    <tools-table class="audit-table" [Headers]="headers" #deviceTable [Search]="false" [Data]="data" [Slim]="true"
        [DisplayCount]="data.length">
    </tools-table>
    }

    @if(isLoading && data.length === 0) {
    <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
    }

</div>